import { createContext, useContext } from 'react';

export type AuthSourceKind = 'clerk' | 'lamma';

export type SignOutResult = { ended: true; leaveTo: string | null } | { ended: false };

/** The page load's one auth source: a Clerk session, a Lamma session, or none (signed-out visitor). */
export interface AuthSourceValue {
  kind: AuthSourceKind | null;
  isLoaded: boolean;
  isSignedIn: boolean;
  accessToken: string | null;
  getToken: () => Promise<string | null>;
  /** Lamma: leaveTo is the provider's logout page; ended is false when the server could not end it. */
  signOut: () => Promise<SignOutResult>;
  /** Ends any session without leaving the page; true when one ended. */
  endSession: () => Promise<boolean>;
  /** Mounts Clerk for the rest of the page load; a no-op under a Lamma session. */
  requestClerk: () => void;
}

export const SIGNED_OUT_SOURCE: AuthSourceValue = {
  kind: null,
  isLoaded: true,
  isSignedIn: false,
  accessToken: null,
  getToken: async () => null,
  signOut: async () => ({ ended: true, leaveTo: null }),
  endSession: async () => false,
  requestClerk: () => undefined,
};

export const AuthSourceContext = createContext<AuthSourceValue>(SIGNED_OUT_SOURCE);

export const useAuthSource = (): AuthSourceValue => useContext(AuthSourceContext);
